<template>
  <div class="bg">
    <div class="top">
      <div class="text">
        <div class="title">
          Modeling & Analytics
        </div>
        <div class="value">
          Holden’s modeling and analytics services help you to manage your extensive & unfiltered data sets to provide direct and sharp business insights. The dataset can come from a well-structured research project, or from daily operation data.

        </div>
        <div><button @click="contact">REQUEST A BID</button></div>
      </div>
    </div>

    <!-- 中间文字 -->
    <div class="data">
      <div class="img"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/modeling/data.jpg"></div>
      <div class="text">Our data engineers and statisticians can also recommend the appropriate research model at the beginning of your study. Through leveraging our <span @click="toguid('/toolbox?source=webtable','SurveyPanda');btn('/toolbox?source=webtable','SurveyPanda')" style="color:#159445;cursor:pointer">SurveyPanda</span> and modeling platform you can construct highly optimized and effective solutions for your business questions.
        Some of the built-in models include MaxDiff, Turf, Conjoint analysis, PSM and KANO models.

      </div>
    </div>

    <!-- 下面的表格 -->
    <div class="table">

      <el-dropdown>
        <span class="el-dropdown-link">
          regression analysis
        </span>
        <el-dropdown-menu slot="dropdown">
          <div class="value">Helps show a correlation (or lack of) between two variables. You can determine whether one set of data depends on another set of data in a cause-and-effect relationship.
          </div>
        </el-dropdown-menu>
      </el-dropdown>

      <el-dropdown>
        <span class="el-dropdown-link">
          correlation analysis
        </span>
        <el-dropdown-menu slot="dropdown" class="value">
          <div class="value">Used to measure the strength of the linear relationship between two variables and compute their association. </div>
        </el-dropdown-menu>
      </el-dropdown>

      <el-dropdown>
        <span class="el-dropdown-link">
          Factor analysis
        </span>
        <el-dropdown-menu slot="dropdown">
          <div class="value">Performs data dimensionality reduction on multiple sets of data.
            Factor analysis is the practice of condensing many variables into just a few, so that your research data is easier to work with.
          </div>
        </el-dropdown-menu>
      </el-dropdown>

      <el-dropdown>
        <span class="el-dropdown-link">
          Cluster analysis
        </span>
        <el-dropdown-menu slot="dropdown">
          <div class="value">A multivariate data mining technique whose goal is to group objects (eg, customer, entities, products) into classes based on a set of user selected characteristics or attributes.
          </div>
        </el-dropdown-menu>
      </el-dropdown>

      <el-dropdown>
        <span class="el-dropdown-link">
          Correspondence analysis
        </span>
        <el-dropdown-menu slot="dropdown">
          <div class="value">A useful data science visualization technique for finding out and displaying the relationship between categories. It uses a graph that plots data, visually showing the outcome of two or more data points. It is often used in Brand Positioning study.
          </div>
        </el-dropdown-menu>
      </el-dropdown>

      <el-dropdown>
        <span class="el-dropdown-link">
          Structural equation model
        </span>
        <el-dropdown-menu slot="dropdown">
          <div class="value">Very frequently applied by marketing and business professionals to assess empirically new theoretical proposals. It is used for testing and evaluating multivariate causal relationships.
          </div>
        </el-dropdown-menu>
      </el-dropdown>

    </div>

    <!-- 尾部 -->
    <div class="talk">
      <div class="value">Talk to our Data Engineer and Quantitative Consultant </div>
      <button @click="contact">Contact</button>
    </div>
  </div>
</template>

<script>
import { advertisementFlow } from "@/api/api";

export default {
  data() {
    return {};
  },
  created() {
    this.loading();
    this.advertisementFlow(); // 在组件创建时加载Google代码
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-11335422054";
    document.head.appendChild(script);
    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments);
      }
      gtag("js", new Date());
      gtag("config", "AW-11335422054");
    };
    this.webinercookies();
  },
  methods: {
    btn(path, id) {
      // 跳转页面
      this.$router.push({
        path
      });
      this.isShow = false;
      if (id) {
        document.getElementById(id).scrollIntoView({ behavior: "smooth" });
      }
      // console.log(index);
    },
    toguid(path, id) {
      var Id = id;
      localStorage.setItem("toId", Id);
      this.$router.push({ path });
    },
    webinercookies() {
      // 如果没有记录cookie
      if (!localStorage.getItem("webinersource")) {
        // 就不重新赋值
        let webinersource = this.$route.query.source;

        if (webinersource == undefined) {
          localStorage.setItem("webinersource", "www");
        } else {
          localStorage.setItem("webinersource", webinersource);
        }
        // console.log(1);
      } else {
        // 如果没有cookie就设置cookie
      }
    },
    advertisementFlow() {
      // 如果没有source
      if (this.$route.query.source == undefined) {
        // console.log(1);
        // 就把source拼接
        advertisementFlow({
          path: "modeling",
          source: "",
          information: "Solutions_modeling"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
        // 如果有source
      } else {
        advertisementFlow({
          path: "modeling",
          source: this.$route.query.source,
          information: "Solutions_modeling"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
      }
    },
    contact() {
      let routeData = this.$router.resolve({ path: "/contact?source=bid" });
      window.open(routeData.href, "_blank");
    },
    loading() {
      this.$loading({
        lock: true,
        background: "rgba(255, 255, 255,1)"
      });
      setTimeout(() => {
        this.$loading().close();
      }, 700);
    }
  }
};
</script>

<style lang="scss" scoped>
.bg {
  background-image: url("https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/modeling/bg1.jpg");
  background-attachment: fixed;
  background-size: cover;
}
.top {
  background-color: #fff;
  padding: 115px 200px;
  // height: 600px;
  background-image: url("https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/modeling/modelingbg.png");
  background-size: cover;
  .text {
    color: #fff;
    width: 60%;
    .title {
      width: 70%;
      font-size: 50px;
      font-weight: 700;
      margin-bottom: 25px;
    }
    .value {
      font-size: 20px;
    }
    button {
      border: none;
      background-color: #2cb1e9;
      color: #fff;
      font-size: 20px;
      border-radius: 10px;
      margin-top: 20px;
      padding: 10px;
    }
  }
}
.data {
  background-color: #fff;
  display: flex;
  flex-wrap: wrap;
  padding: 80px 120px;
  .img {
    width: 45%;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .text {
    background-color: #2cb1e9;
    padding: 50px;
    width: 55%;
    font-size: 23px;
    color: #fff;
  }
}
.table {
  background-color: rgba(255, 255, 255, 0.5);
  padding: 80px 120px 0 120px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 0;
}
.talk {
  background-color: #2cb1e9;
  display: flex;
  justify-content: space-between;
  padding: 50px 120px;
  font-size: 30px;
  font-weight: 700;
  color: #fff;
  button {
    background-color: #4f81bd;
    border: none;
    font-size: 23px;
    border-radius: 10px;
    padding: 10px;
  }
}
@media screen and (max-width: 576px) {
  .top {
    padding: 80px 100px;
    .text {
      width: 100%;
      .title {
        width: 80%;
        font-size: 110px;
      }
      .value {
        font-size: 70px;
      }
      button {
        font-size: 70px;
        padding: 10px 20px;
      }
    }
  }
  .data {
    display: block;
    .img {
      width: 100%;
    }
    .text {
      width: 100%;
      font-size: 70px;
    }
  }
}
</style>
<style lang="scss">
.el-dropdown {
  width: 30%;
  text-align: center;
  background-color: #2cb1e9;

  margin-bottom: 80px;
  .el-dropdown-link {
    display: flex;
    align-items: center;
    justify-content: center;
    // display: inline-block;
    padding: 10px;
    text-align: center;
    height: 150px;
    // background-color: #2cb1e9;
    font-size: 40px;
    font-weight: 700;
    color: #fff;
  }
}
.el-dropdown-menu {
  width: 550px;
  font-size: 23px;
  background-color: #d0e3ea;
  padding: 10px;
}
@media screen and (max-width: 576px) {
  .el-dropdown {
    width: 100%;
    .el-dropdown-link {
      font-size: 80px;
      height: 300px;
      padding: 20px;
      width: 100%;
    }
  }
  .el-dropdown-menu {
    width: 90%;
    font-size: 70px;
    padding: 20px;
  }
}
</style>